import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Button,
  Table,
  Alert,
  Spinner,
  ButtonGroup,
} from "react-bootstrap";
import { fetchOrderSettings } from "../redux/slice/orderSettingsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDailyStats,
  fetchMonthlyStats,
  exportStatsCSV,
} from "../redux/slice/statsSlice";
import "../assets/Calendar.css";
import GroupPercentageStats from "../components/GroupPercentageStats";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Stats = () => {
  const dispatch = useDispatch();

  const {
    dailyStats,
    dailySnapshot,
    monthlyStats,
    statusDaily,
    statusMonthly,
    statusCSV,
    errorDaily,
    errorMonthly,
  } = useSelector((state) => state.stats);
  const { rules } = useSelector((state) => state.orderSettings);

  const today = new Date();
  const currentMonthDefault = String(today.getMonth() + 1);
  const currentYearDefault = today.getFullYear();

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [month, setMonth] = useState(currentMonthDefault);
  const [year, setYear] = useState(currentYearDefault);
  const [message, setMessage] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("monthly");


  //  AUTO LOAD MONTHLY ON MOUNT
  useEffect(() => {
    dispatch(fetchMonthlyStats({ month: currentMonthDefault, year: currentYearDefault }));
    dispatch(fetchOrderSettings());
  }, [dispatch]);

  //  DAILY FETCH
  const fetchDaily = () => {
    dispatch(fetchDailyStats({ date }))
      .unwrap()
      .catch(() => setMessage("Σφάλμα κατά τη λήψη των καθημερινών δεδομένων"));
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (activeTab === "daily" && date) {
      fetchDaily();
    }
  }, [activeTab]);

  const handleExportDaily = () => {
    dispatch(exportStatsCSV({ type: "daily", date }))
      .unwrap()
      .then((blob) => {
        const url = URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `daily_stats_${date}.csv`;
        a.click();
      })
      .catch(() => setMessage("Σφάλμα κατά την εξαγωγή CSV"));
  };

  //  MONTHLY FETCH
  const fetchMonthly = () => {
    dispatch(fetchMonthlyStats({ month, year }))
      .unwrap()
      .catch(() => setMessage("Σφάλμα κατά τη λήψη των μηνιαίων δεδομένων"));
  };

  const handleExportMonthly = () => {
    dispatch(exportStatsCSV({ type: "monthly", month, year }))
      .unwrap()
      .then((blob) => {
        const url = URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `monthly_stats_${month}_${year}.csv`;
        a.click();
      })
      .catch(() => setMessage("Σφάλμα κατά την εξαγωγή CSV"));
  };
  const sortedDailyStats = [...(dailyStats || [])].sort(
    (a, b) => b.total_meals - a.total_meals
  );

  const sortedMonthlyStats = [...(monthlyStats || [])].sort(
    (a, b) => b.total_meals - a.total_meals
  );

  const resolveGroup = (stat, ruleSet = []) => {
    if (stat?.group && ["A", "B"].includes(stat.group)) {
      return stat.group;
    }

    const desc = stat?.description_name?.toUpperCase();
    const match = ruleSet?.find(
      (rule) => rule?.description_name?.toUpperCase() === desc
    );
    return match?.group || "B";
  };

  const dailyRules = dailySnapshot?.rules?.length ? dailySnapshot.rules : rules;

  return (
    <Container className="mt-4" style={{ minHeight: "100vh" }}>
      <Card className="shadow-sm" style={{ borderRadius: 14 }}>
        <Card.Header style={{ background: "white", padding: "20px 25px" }}>
          <h3 style={{ margin: 0, fontWeight: 600 }}>Στατιστικά Γευμάτων</h3>
        </Card.Header>
        <div
          style={{
            display: "flex",
            background: "#f1f3f5",
            padding: 5,
            borderRadius: 14,
            marginBottom: 30,
          }}
        >
          <div
            onClick={() => setActiveTab("monthly")}
            style={{
              flex: 1,
              padding: "12px 0",
              textAlign: "center",
              fontWeight: 600,
              cursor: "pointer",
              borderRadius: 12,
              background: activeTab === "monthly" ? "white" : "transparent",
              boxShadow: activeTab === "monthly" ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
              transition: "0.2s",
            }}
          >
            Μηνιαία Στατιστικά
          </div>

          <div
            onClick={() => setActiveTab("daily")}
            style={{
              flex: 1,
              padding: "12px 0",
              textAlign: "center",
              fontWeight: 600,
              cursor: "pointer",
              borderRadius: 12,
              background: activeTab === "daily" ? "white" : "transparent",
              boxShadow: activeTab === "daily" ? "0 2px 6px rgba(0,0,0,0.08)" : "none",
              transition: "0.2s",
            }}
          >
            Ημερήσια Στατιστικά
          </div>
        </div>


        <Card.Body style={{ padding: "25px" }}>
          {message && <Alert variant="danger">{message}</Alert>}

          {/*              Μηναια αναφορά             */}
          {activeTab === "monthly" && <>
            <h4 style={{ marginBottom: 15 }}>Μηνιαία Στατιστικά ανά Ειδικότητα</h4>
            <Row className="align-items-center mb-4" style={{ display: 'flex', justifyContent: 'left', flexDirection: 'row' }}>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Μήνας</Form.Label>
                  <Form.Select
                    style={{ height: 55, borderRadius: '10px' }}
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                  >
                    <option value="1">Ιανουάριος</option>
                    <option value="2">Φεβρουάριος</option>
                    <option value="3">Μάρτιος</option>
                    <option value="4">Απρίλιος</option>
                    <option value="5">Μάιος</option>
                    <option value="6">Ιούνιος</option>
                    <option value="7">Ιούλιος</option>
                    <option value="8">Αύγουστος</option>
                    <option value="9">Σεπτέμβριος</option>
                    <option value="10">Οκτώβριος</option>
                    <option value="11">Νοέμβριος</option>
                    <option value="12">Δεκέμβριος</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={2} md={3} sm={3} xs={12} className="btn-group-container">
                <Form.Group style={{ paddingTop: `${isMobile ? '10px' : '0px'}`, }}>
                  <Form.Label>Έτος</Form.Label>
                  <Col className="btn-group-container">
                    <ButtonGroup className="btn-container">
                      <Button className="btn-order" style={{ padding: '20px', marginRight: '10px' }} variant="primary" onClick={() => setYear((prev) => prev - 1)} >
                        <FontAwesomeIcon icon={faArrowLeft} />
                      </Button>
                      <Button style={{ padding: '20px', }} className="btn-order" variant="outline-dark" >
                        <span style={{ fontWeight: '400', }}>{year}</span>
                      </Button>
                      <Button className="btn-order" style={{ padding: '20px', marginLeft: '10px' }} variant="primary" onClick={() => setYear((prev) => prev + 1)} >
                        <FontAwesomeIcon icon={faArrowRight} />
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Form.Group>
              </Col>

              <Col md={4}  className="mt-4" style={{ display: 'flex', justifyContent: `${isMobile ? 'start' : 'start'}` }}>
                <Button
                  className="btn-email"
                  style={{ height: 55, borderRadius: '10px', padding: '10px 20px', fontSize: '16px' }}
                  onClick={fetchMonthly}
                  disabled={statusMonthly === "loading"}
                >
                  {statusMonthly === "loading" ? <Spinner size="sm" /> : "Προβολή"}
                </Button>

              </Col>
            </Row>

            {errorMonthly && <Alert variant="danger">{errorMonthly}</Alert>}

            {monthlyStats?.length === 0 && (
              <Alert variant="warning">Δεν Βρέθηκαν Στατιστικά</Alert>
            )}
            {monthlyStats?.length > 0 && (
              <>
                <GroupPercentageStats data={monthlyStats} rules={rules} />
                <Table bordered hover className="mt-3">
                  <thead>
                    <tr>
                      <th>Ειδικότητα</th>
                      <th>Σύνολο Μερίδων</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedMonthlyStats?.map((stat, i) => {
                      const group = resolveGroup(stat, rules);
                      return (
                        <tr key={i}>
                          <td>
                            {stat.description_name}{" "}
                            <span
                              style={{
                                background: group === "A" ? "#4e79a7" : "#e15759",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "12px",
                                marginLeft: "10px"
                              }}
                            >
                              Group {group}
                            </span>

                          </td>

                          <td>{stat?.total_meals}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

              </>
            )}
          </>}

          {/* <hr className="my-5" /> */}

          {/*                     Ημερήσια αναφορά                  */}
          {activeTab === "daily" && <>

            <h4 style={{ marginBottom: 15 }}>Ημερήσια Στατιστικά</h4>

            <Row className="align-items-center">
              <Col md={4} >
                <Form.Group>
                  <Form.Label>Ημερομηνία</Form.Label>
                  <Form.Control
                    type="date"
                    style={{ height: 55, padding: '15px' }}
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={4} style={{ display: 'flex', justifyContent: `${isMobile ? 'space-between' : 'start'}` }}>
                <Button
                  className="btn-email"
                  style={{ height: 55, borderRadius: '10px', padding: '10px 20px', fontSize: '16px' }}
                  onClick={fetchDaily}
                  disabled={!date || statusDaily === "loading"}
                >
                  {statusDaily === "loading" ? <Spinner size="sm" /> : "Προβολή"}
                </Button>

              </Col>
            </Row>

            {errorDaily && <Alert variant="danger">{errorDaily}</Alert>}

            {dailyStats?.length > 0 && (
              <>
                <GroupPercentageStats data={dailyStats} rules={dailyRules} />
                <Table bordered hover className="mt-3">
                  <thead>
                    <tr>
                      <th>Ειδικότητα</th>
                      <th>Μερίδες</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedDailyStats.map((stat, i) => {
                      const group = resolveGroup(stat, dailyRules);
                      return (
                        <tr key={i}>
                          <td>
                            {stat.description_name}{" "}
                            <span
                              style={{
                                background: group === "A" ? "#4e79a7" : "#e15759",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "20px",
                                fontSize: "12px",
                                marginLeft: "10px"
                              }}
                            >
                              Group {group}
                            </span>

                          </td>

                          <td>{stat.total_meals}</td>
                        </tr>
                      );
                    })}
                  </tbody>

                </Table>
              </>
            )}
            {dailyStats?.length === 0 && (
              <Alert variant="warning">Δεν Βρέθηκαν Στατιστικά</Alert>
            )}
          </>}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Stats;
